export const EDITING_REQUEST_PLACEHOLDER_CLASS_NAME = "editing-request-placeholder";
